<app-menu-options></app-menu-options>
<div style="margin-top: 3.2rem;" *ngIf="show_dashboard" >
    <app-insights-dashboard [id]="id" [title]="title" [height]="'calc(100vh - 7.5rem)'" [width]="'100vw'"></app-insights-dashboard>
</div>
